/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import VolumeIcon from '../icons/Sound';
import Button from './Button';

import styles from '../../styles/buttons/volume.module.css';

const propTypes = {
    volume: PropTypes.number,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

function VolumeButton({ volume = 1, onClick = null, className = null, ...props }) {
    return (
        <Button
            aria-label="Volume"
            onClick={onClick}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        >
            <VolumeIcon volume={volume} className={styles.icon} />
        </Button>
    );
}

VolumeButton.propTypes = propTypes;

export default VolumeButton;
